import * as Actions from 'reducks/confirm/actions'
import { initialState } from 'reducks/reduxStore/initialState'

export const ConfirmReducer = (state = initialState.confirm, action: any) => {
  switch (action.type) {
    case Actions.UPDATE_EDIT_STATE:
      return {
        ...state,
        is_being_edited: action.payload,
      }
    case Actions.SAVE_COLLECTIVE_STOCKS_CONFIRM:
      return {
        ...state,
        collective_stocks: { ...action.payload },
      }
    case Actions.SAVE_CALENDAR_CONFIRM:
      return {
        ...state,
        store: {
          ...state.store,
          holidays: [...action.payload.holidays],
          business_hours: { ...action.payload.open_time },
          order_start_time: { ...action.payload.order_start_time },
          last_order_time: { ...action.payload.last_order_time },
          last_pickup_time: { ...action.payload.last_pickup_time },
          relative_pickupable_time: { ...action.payload.relative_pickupable_time },
        },
      }
    case Actions.SAVE_STORE_CONFIRM:
      return {
        ...state,
        store: { ...action.payload.store },
      }
    case Actions.SAVE_STORE_GEO_SEARCH_CONFIRM:
      return {
        ...state,
        store_geo_search: { ...action.payload.storeGeoSearch },
      }
    case Actions.SAVE_STORE_CALENDARS_CONFIRM:
      return {
        ...state,
        store_calendars: [...action.payload.store_calendars],
      }
    case Actions.INIT_CONFIRM:
      return {
        ...initialState.confirm,
      }
    default:
      return state
  }
}
